import { useFieldArray, useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { DataList } from "@/common/DataList";
import type { GeneralInfoTabFormValues } from "@/entities/general-info-tab-content/model";
import { EmailField } from "./EmailField";

type Props = {
  personId: string;
  isEditMode: boolean;
  handleEditMode: () => void;
  onSubmit: (data: GeneralInfoTabFormValues) => void;
  disabled?: boolean;
};

export const EmailsList = ({ personId, isEditMode, handleEditMode, onSubmit, disabled }: Props) => {
  const { t } = useTranslation();

  const { control, getValues, trigger } = useFormContext<GeneralInfoTabFormValues>();

  const { fields, append, remove } = useFieldArray({
    control,
    name: "emails",
  });

  const onBlur = async () => {
    const isValid = await trigger("emails");

    if (isValid) {
      const formData = getValues();
      onSubmit(formData);
    }
  };

  const onChange = () => {
    trigger("emails");
  };

  const addHandler = () => {
    if (!isEditMode) {
      handleEditMode();
    }

    setTimeout(() => {
      append({ emailType: { name: "" }, email: "", id: undefined, personId });
    }, 0);
  };

  const removeHandler = async (index: number) => {
    remove(index);

    const isValid = await trigger("emails");

    if (isValid) {
      const formData = getValues();
      onSubmit(formData);
    }
  };

  return (
    <DataList
      data={fields.map((item) => ({
        id: item?.id ?? "",
        label: item?.emailType?.name ?? "",
        value: item?.email ?? "",
      }))}
      onAddClick={addHandler}
      onTrashClick={removeHandler}
      isEdit={isEditMode}
      title={t("contactsPage.generalInfo.emails")}
      editNode={(index) => <EmailField index={index} onBlur={onBlur} onChange={onChange} />}
      disabled={disabled}
    />
  );
};
